module.exports = __webpack_public_path__ + "img/second-page-icon-2.a4db01b1.svg";